import {
  isActivityLogPostBlocked,
  markActivityLogRateLimitedFromError,
} from '@/utils/activityLogging/activityLogClientRateLimit';
import axios from 'axios';

interface LogoutActivityInput {
  reason: string;
  userEmail?: string | null;
}

export async function logLogoutActivity({
  reason,
  userEmail,
}: LogoutActivityInput): Promise<void> {
  if (isActivityLogPostBlocked()) {
    return;
  }

  try {
    await axios.post('/api/activities', {
      activityData: {
        module: 'Authentication',
        feature: 'Logout',
        status: 'Info',
        messageTemplateId: 'authentication_logout',
        messageParams: {
          reason,
          ...(userEmail != null && userEmail !== '' ? { userEmail } : {}),
        },
      },
    });
  } catch (error) {
    if (!markActivityLogRateLimitedFromError(error)) {
      console.error('Failed to log logout activity:', error);
    }
  }
}
